import type { ChatChartProposal } from '@/features/ara-generation/types/ara-chat'
import type { AraChartEditFrame, AraEditTarget } from '@/features/ara-generation/types/ara-events'
import type { AraVariantEditState } from '@/features/ara-generation/types/ara-workspace'

export function collectChartProposal(
  frame: AraChartEditFrame,
  scopedTarget?: AraEditTarget | null
): ChatChartProposal | null {
  const patch = frame.patch
  if (typeof patch !== 'object' || patch === null || Array.isArray(patch)) return null
  if (Object.keys(patch).length === 0) return null

  const chartKey = frame.chart_key.trim()
  const targetId = scopedTarget?.id.trim() ?? ''
  const chartId = chartKey || targetId || (scopedTarget?.key.trim() ?? '')
  if (!chartId) return null

  return {
    kind: 'chart',
    chartKey,
    chartId,
    patch,
    target: scopedTarget ?? undefined,
    status: 'idle'
  }
}

export function applyChartProposalToState(
  edit: AraVariantEditState,
  proposal: ChatChartProposal
): AraVariantEditState {
  const prevOverrides =
    (edit.structuredAra.chart_overrides as Record<string, Record<string, unknown>> | undefined) ??
    {}
  return {
    ...edit,
    structuredAra: {
      ...edit.structuredAra,
      chart_overrides: { ...prevOverrides, [proposal.chartId]: proposal.patch }
    }
  }
}
